export const Logo = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden>
    <rect x="3" y="3" width="58" height="58" rx="15" fill="#3B0B12" />
    <rect x="4.5" y="4.5" width="55" height="55" rx="13.5" fill="none" stroke="#D4AF37" strokeWidth="2.5" />
    <path d="M27 19 L42 15.5 L42 45 L27 48.5 Z" fill="#0E2A1E" stroke="#D4AF37" strokeWidth="2" />
    <path d="M25 21 L17 26.5 L17 43 L25 46.5 Z" fill="#D4AF37" />
    <path d="M46 21 l2 4.2 4.6.6-3.3 3.2.8 4.6-4.1-2.2-4.1 2.2.8-4.6-3.3-3.2 4.6-.6z" fill="#F3E5AB" />
  </svg>
);
